import { components } from "@/api-schema";
import { SubComponentInfoCard } from "@/components/data-table/predefined/_components/sub-component-info-card";
import { DataTableRow } from "@/components/data-table/types";
import { BuildingIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

type Vehicle = components["schemas"]["Vehicle"];

export interface VehicleSubComponentProps {
  row: DataTableRow<Vehicle>;
}

export function VehicleSubComponent({ row }: VehicleSubComponentProps) {
  const { t } = useTranslation("common");
  const owningBranch = row.original.owningBranch;

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {owningBranch?.name && (
        <SubComponentInfoCard
          icon={BuildingIcon}
          label={t("common:OwningBranch")}
          value={owningBranch.name}
          relation={{ subject: "Branch", uuid: owningBranch.uuid }}
        />
      )}
    </div>
  );
}
